import React from 'react'
import classNames from 'classnames'
import { GalleryTabType } from '../types'

interface TabNavigationProps {
  activeTab: GalleryTabType
  onTabChange: (tab: GalleryTabType) => void
}

export const TabNavigation: React.FC<TabNavigationProps> = ({ 
  activeTab, 
  onTabChange 
}) => {
  const tabs = [
    { key: 'style-shot' as GalleryTabType, label: '스타일 샷' },
    { key: 'style-clip' as GalleryTabType, label: '스타일 클립' },
  ]

  return (
    <div className="flex gap-6 mb-4">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={classNames(
            'relative pb-1 font-bold text-base transition-colors',
            {
              'text-[#2E343D]': activeTab === tab.key,
              'text-[#B6BBC6]': activeTab !== tab.key,
            }
          )}
        >
          {tab.label}
          {activeTab === tab.key && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2E343D]" />
          )}
        </button>
      ))}
    </div>
  )
}